import Component from '../core/Component'

export const STATUS = {
    ACTIVE: 'is-active'
}

export default class FilterLayerOpener extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()

        const target = document.getElementById(event.target.hash.replace('#', ''))

        if (target) {
            const layer = Component.getFromElement(target)

            if (layer) {
                this.element.classList.add(STATUS.ACTIVE)
                layer.onClose = ::this.handleClose
                layer.toggle(event.target)
            }
        }
    }

    handleClose() {
        this.element.classList.remove(STATUS.ACTIVE)
    }
}